// eslint-disable-next-line import/prefer-default-export
export const ShiftStatus = {
  ACTIVE: "active",
  INACTIVE: "inactive"
} as const;
